export default "__VITE_ASSET__CE_cG68L__"